import { $$, JNative } from "../JNative";
import { NAMESPACE } from "./_Namespace";

export class ElementRef<TElement extends HTMLElement = HTMLElement>
{
    public static classNamespace = NAMESPACE + "ElementRef";
    public static className = "ElementRef";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    current: JNative<TElement>;

    constructor()
    {
        this.current = $$();
    }
}